import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import Select, { components } from 'react-select';
import cleanDeep from 'clean-deep';
import _ from "lodash";
import Avatar from 'react-avatar';
import moment from "moment";
import { sentenceCase } from 'change-case';
import {
  InputGroup,
  FormControl,
  Accordion,
  Button,
  ButtonGroup,
  Dropdown
} from "react-bootstrap";
import LinearProgress from '@material-ui/core/LinearProgress';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookmark
} from "@fortawesome/free-solid-svg-icons";
import { ChevronRightIcon, ChevronDownIcon, XIcon, PlusIcon, XCircleIcon, CheckIcon } from "@heroicons/react/outline";
import {
  clearItem,
  updateItem,
  getItemDetail,
  upvoteItem,
  deleteUpvoteItem,
  favoriteItem,
  deleteFavoriteItem,
  updateShortUrl,
  addTagToItem,
  removeTagFromItem
} from "../actions/items";
import {getIconByName} from "../assets/icons";
import ButtonShareWithRecipient from "../components/ButtonShareWithRecipient";
import ContentTagEditor from "../components/dashboard/ContentTagEditor";
import UploadModalContent from "../components/dashboard/UploadModalContent";
import TitleEditable from "../components/TitleEditable";
import ContentEditable from "../components/ContentEditable";
import ThumbnailEditor from "../components/details/ThumbnailEditor";
import { copyToClipboard } from "../utils/common";
import truncateString from "../utils/truncateString";
import iconUpvoteFilled from "../assets/images/icon-upvote-filled.svg";
import iconUpvoteOutlined from "../assets/images/icon-upvote-outline.svg";
import iconFavoriteFilled from "../assets/images/icon-sq-24-star-filled.svg";
import iconFavoriteOutlined from "../assets/images/icon-sq-24-star-outline.svg";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { addEventNameToEndpoint } from '../utils/common';
import FileViewMaster from '../components/FileViewMaster';
import ItemDetailViewsTable from '../components/ItemDetailViewsTable';
import ActionConfirmForm from '../components/common/ActionConfirmForm';
// import { copyToClipboard, MESSAGES } from "../utils/common";
import { PROMPT_ACTION_FORM } from "../constants/Messages";
import { ShareType } from "../constants/Types";
import "./ItemDetails.scss";
import { USER_SETTINGS } from "../constants/UserSettings";
import { info } from "sass";

const ReactSwal = withReactContent(Swal);

const ASSET_USE = {
  EXTERNAL: "External",
  INTERNAL: "Internal"
};

const accessibilityOptions = [
  { value: true, label: ASSET_USE.EXTERNAL },
  { value: false, label: ASSET_USE.INTERNAL },
];

// fields to filter out of additional info
const META_FILTER_FIELDS = [
  "contentTags",
  "contentTitle",
  "contentType",
  "funnelStage",
  "contentDescription",
  "contentPositioning",
  "contentProduct",
  "contentIndustry",
  "contentRegion",
  "isShared",
  "updateThumbnail"

];

const selectStyles = (width) => {
  return {
    control: styles => ({
      ...styles,
      backgroundColor: 'white',
      height: 32,
      width,
      minHeight: 20,
      marginRight: 10
    }),
    // option: (provided, state) => ({
    //   ...provided,
    //   backgroundColor: state.isSelected ? '#3FC2CD' : state.isFocused ? '#fff' : null,
    //   color: state.isSelected ? '#fff' : '#000',
    // }),
    menu: (styles) => ({ ...styles, width }),
  }
};

class ItemDetails extends Component {
  constructor(props) {
    super(props);

    this.shareLinkRef = React.createRef();
    this.state = {
      shortUrl: '',
      // categorization
      selectedTags: [],
      selectedAssetUse: null,
      selectedFunnelStage: [], // Change to array for multi-select
      selectedContentType: [], // Change to array for multi-select
      selectedProduct: [], // Change to array for multi-select
      selectedIndustry: [], // Change to array for multi-select
      selectedRegion: [], // Change to array for multi-select
      // view state
      isEditShortUrl: false,
      isOpenContentDetails: true,
      isOpenAddedBy: true,
      isOpenContentMeta: true,
      isOpenSharingDetails: true,
      isOpenAdditionalInfo: true
    }
  }

  componentWillUnmount() {
    if (this.props.details) {
      this.props.clearItem(this.props.details.id);
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.details && props.details.id) {
      return {
        shortUrl: state.shortUrl === '' ? _.get(props.details, 'urls.short', '') : state.shortUrl,
      }
    } else {
      if (props.error) {
        props.history.push('/dashboard');
      }
    }

    return null;
  }

  componentDidMount() {
    // From willMount
    this.props.getItemDetail(_.get(this.props, 'match.params.itemId', null));
    //////
    const detailObj = this.props.details;
    if (detailObj) {
      this.setState({
        shortUrl: _.get(detailObj, 'urls.short', '')
      });
    }
  }

  /**
   * Editing is enabled if the user is an admin OR the user owns the item
   * @returns {boolean} true if the item can be edited
   */
  isEditingEnabled = () => {
    const isAdmin = _.get(this.props, 'cognitoUser.attributes', {})['custom:role'] === 'admin';
    const userId = _.get(this.props, "cognitoUser.username", '');
    const itemOwnerId = _.get(this.props, "details.ownerId", '');
    return (isAdmin || (userId && userId === itemOwnerId));
  };

  handleUpdateItem = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <UploadModalContent
          user={this.props.user}
          cognitoUser={this.props.cognitoUser}
          itemId={_.get(this.props, 'match.params.itemId', 'null')}
          path={_.get(this.props.history, 'location.pathname', '')}
          onClose={ReactSwal.clickCancel}
          Auth={this.props.Auth}
          Analytics={this.props.Analytics}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  onSaveDetails = async () => {
    this.props.updateItem(this.props.details);
  };

  handleTagChange = (tag) => {
    this.props.addTagToItem(this.props.details.id, tag.key, {
      color: tag.color,
      sort: tag.sort,
      createdBy: tag.createdBy
    });
  }

  handleDeleteTag = (key) => {
    this.props.removeTagFromItem(this.props.details.id, key);
  }

  onClickCopyShortUrl = () => {
    addEventNameToEndpoint(this.props.Analytics, 'user-shorturl-copy');
    copyToClipboard(this.state.shortUrl);
  }

  onClickShortener = () => {
    addEventNameToEndpoint(this.props.Analytics, 'admin-shorturl-customize');

    if (!this.state.isEditShortUrl) {
      this.setState({ isEditShortUrl: true });
    } else {
      const { shortUrl } = this.state;
      const existingUrl = _.get(this.props.details, 'urls.short', '');
      const existingPaths = existingUrl.split('/');
      const paths = shortUrl.split('/');
      const newPath = paths[paths.length - 1];
      const existingPath = existingPaths[existingPaths.length - 1];
      this.props.updateShortUrl(this.props.details.id, existingPath, newPath);
      this.setState({ isEditShortUrl: false });
    }
  }

  handleUpvote = (id, isAddUpvote) => {
    addEventNameToEndpoint(this.props.Analytics, isAddUpvote ? 'user-item-upvote' : 'user-item-unupvote');

    if (isAddUpvote) {
      this.props.upvoteItem(id);
    } else {
      this.props.deleteUpvoteItem(id);
    }
  }

  getFileName = () => {
    let fileName = truncateString(_.get(this.props,'details.name', ''), 40);
    fileName = truncateString(_.get(this.props,'details.original.name', fileName), 40);
    return fileName;
  }

  handleFavorite = (id, isFavorite) => {
    addEventNameToEndpoint(this.props.Analytics, isFavorite ? 'user-item-unfavorite' : 'user-item-favorite');
    
    if (isFavorite) {
      this.props.deleteFavoriteItem(id);
    } else {
      this.props.favoriteItem(id);
    }
  }

  renderAdditionalInfo = () => {
    // meta info
    const metaInfo = _.get(this.props, 'details.meta', {});
    const keys = Object.keys(metaInfo).filter(key => !META_FILTER_FIELDS.includes(key));
    // add some details keys
    const dateAdded = moment.parseZone(_.get(this.props, 'details.createdAt', '')).format('MMM DD, YYYY hh:mm a');
    const name = _.get(this.props, 'details.name', null);
    const sourceUrl = _.get(this.props, 'details.urls.source', null);
    keys.push('dateAdded');
    metaInfo['dateAdded'] = dateAdded;
    keys.push('originalName');
    metaInfo['originalName'] = name;
    if (sourceUrl) {
      keys.push('sourceUrl');
      metaInfo['sourceUrl'] = sourceUrl;
    }

    const additionalInfo = keys.map((key, index) =>
      <div key={`${key}_${index}`}>
        <p className="label">{sentenceCase(key)}</p>
        <p className="value">{JSON.stringify(metaInfo[key])}</p>
      </div>
    );

    return additionalInfo;
  }

  handleChangeAccessibility = (e) => {
    const { details } = this.props;
    
    const newDetails = cleanDeep({
      id: details.id,
      meta: {
        isShared: e.value
      }
    });

    this.props.updateItem(newDetails);
    this.setState({ sharedOption: e });
  }

  onChangeSelection = params => {
    const newDetails = cleanDeep({
      id: this.props.details.id,
      meta: {
        ...params
      }
    });

    this.props.updateItem(newDetails);
  };

  // Handle multi-select changes
  onChangeMultiSelection = (key, selectedData, action) => {
    // console.log({key, selectedData, action, info: 'onChangeMultiSelection'});
    const selectedValues = selectedData ? selectedData.map(data => data.value) : "";
    // console.log({selectedValues, info: 'onChangeMultiSelection'});
    let newDetails = {
      id: this.props.details.id,
      meta: {}
    };
    newDetails.meta[key] = selectedValues.length > 0 ? selectedValues : [];
    // console.log({newDetails, info: 'onChangeMultiSelection'});
    this.props.updateItem(newDetails);
  };

  changeNotificationPermission = () => {
    if (_.get(this.props.settings, `userInfo.${USER_SETTINGS.APP_OPTIONS.PUSH_ENABLED}`, true)) {
      if (!('Notification' in window)) {
        console.log("This browser does not support notifications.");
      } else {
        if (Notification.permission !== 'granted' && Notification.permission !== 'denied') {

          ReactSwal.fire({
            allowOutsideClick: true,
            allowEscapeKey: true,
            allowEnterKey: false,
            showCancelButton: false,
            showConfirmButton: false,
            html: (
              <ActionConfirmForm
                onConfirm={ReactSwal.clickConfirm}
                onClose={ReactSwal.clickCancel}
                title={PROMPT_ACTION_FORM.NOTIFICATIONS.TITLE}
                question={PROMPT_ACTION_FORM.NOTIFICATIONS.BODY}
              />
            )
          })
          .then(async result => {
            if (result.value) {
              try {
                await Notification.requestPermission();
              } catch (error) {
                console.log('error happened during request permission for browser notification');
                console.log(error);
              }
            }
          });
        }
      }
    }
  }

  formatMultiSelectValues = (selectData) => {
    let formattedData = { value: '', label: '' };
    if (!selectData) {
      return null;
    }
    if (Array.isArray(selectData)) {
      formattedData = selectData.map(value => ({
        value: value,
        label: value
      }));
    } else {
      formattedData = [{ value: selectData, label: selectData }];
    }
    return formattedData;
  }

  CustomOption = (props) => {
    return (
      <components.Option {...props}>
      <div
        className={props.isSelected ? 'content_select__option content_select__option--is-selected' : 'content_select__option'}
      >
        {props.label}
      </div>
    </components.Option>
    );
  };

  CustomMultiValue = () => null;

  render() {
    const {
      isEditShortUrl,
      isOpenAddedBy,
      isOpenContentDetails,
      isOpenContentMeta,
      isOpenSharingDetails,
      isOpenAdditionalInfo,
      shortUrl
    } = this.state;

    const {
      contentTypes,
      funnelStages,
      contentProducts,
      contentIndustries,
      contentRegions,
      appOptions
    } = this.props.settings;

    const funnelOptions = Object.keys(funnelStages).map(key => ({
      value: key,
      label: key
    }));

    const contentTypeOptions = Object.keys(contentTypes).map(key => ({
      value: key,
      label: key
    }));

    const contentProductOptions = Object.keys(contentProducts || {}).map(key => ({
      value: key,
      label: key
    }));

    const contentIndustryOptions = Object.keys(contentIndustries || {}).map(key => ({
      value: key,
      label: key
    }));

    const contentRegionOptions = Object.keys(contentRegions || {}).map(key => ({
      value: key,
      label: key
    }));

    const { details } = this.props;
    const funnelStage = this.formatMultiSelectValues(_.get(details, 'meta.funnelStage', []));
    const funnelStageTitle = funnelStage ? funnelStage.map((option) => option.value).join(", ") : "";
    const contentType = this.formatMultiSelectValues(_.get(details, 'meta.contentType', []));
    const contentTypeTitle = contentType ? contentType.map((option) => option.value).join(", ") : "";
    const contentProduct = this.formatMultiSelectValues(_.get(details, 'meta.contentProduct', []));
    const contentProductTitle = contentProduct ? contentProduct.map((option) => option.value).join(", ") : "";
    const contentIndustry = this.formatMultiSelectValues(_.get(details, 'meta.contentIndustry', []));
    const contentIndustryTitle = contentIndustry ? contentIndustry.map((option) => option.value).join(", ") : "";
    const contentRegion =this.formatMultiSelectValues(_.get(details, 'meta.contentRegion', []));
    const contentRegionTitle = contentRegion ? contentRegion.map((option) => option.value).join(", ") : "";
    const tags = _.get(details, 'meta.contentTags', {});
    const sharedOption = _.get(details, 'meta.isShared', true) ? { value: true, label: ASSET_USE.EXTERNAL } : { value: false, label: ASSET_USE.INTERNAL };

    const paths = shortUrl.split('/');
    const shortPath = paths[paths.length - 1];
    const domain = shortUrl.slice(0, shortUrl.length - shortPath.length);

    const isEditable = this.isEditingEnabled();
    const isAdmin = _.get(this.props, 'cognitoUser.attributes', {})['custom:role'] === 'admin';
    const userId = _.get(this.props, "cognitoUser.username", '');
    const itemId = _.get(this.props, 'match.params.itemId', 'null');
    const isAddUpvote = !_.get(this.props, 'settings.userInfo.collectionUpvotes', []).includes(itemId.toString());
    const isFavorite = _.get(this.props, 'settings.userInfo.collectionFavorites', []).includes(itemId.toString());
    const addedUser = this.props.settings.users.find(u => u.userId === _.get(this.props, 'details.userId', 'null'));
    const isShared = _.get(this.props, 'details.meta.isShared', true);
    const avatarImage = _.get(addedUser, 'avatar.thumbnail', null);
    const fileName = this.getFileName()

    const titleLong = _.get(this.props, 'details.meta.contentTitle', _.get(this.props, 'details.original.original_basename'));
    const titleShort = truncateString(titleLong, 59);

    return (
      <div className="item-details-container relative">
        {this.props.isLoading && <div className="disable-overlay" onClick={(e) => e.stopPropagation()} />}
        <div className="left-sidebar">
          <Accordion defaultActiveKey="0">
            <Accordion.Toggle eventKey="0" className="w-100 accordion-toggle" onClick={() => this.setState({ isOpenAddedBy: !isOpenAddedBy })}>
              <div className="title d-flex px-2">
                <span>Added by</span>
                {isOpenAddedBy ? <ChevronDownIcon className="icons" /> : <ChevronRightIcon className="icons" />}
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <div className="d-flex added-by">
                {/* {avatarImage ? <img src={avatarImage} width="36px" height="36px" style={{ borderRadius: "50%" }} /> */}
                <Avatar name={_.get(addedUser, "name", "")} size={36} round={true} color="white" fgColor="pink" src={avatarImage} />
                {/* } */}
                <div className="ml-2">
                  <p>{_.get(addedUser, "name", "")}</p>
                  {_.get(addedUser, "type", "") === "user" && <p>Team Member</p>}
                  {_.get(addedUser, "type", "") === "admin" && <p>Admin</p>}
                </div>
              </div>
            </Accordion.Collapse>
          </Accordion>
          <Accordion defaultActiveKey="1">
            <Accordion.Toggle eventKey="1" className="w-100 accordion-toggle top-border" onClick={() => this.setState({ isOpenContentDetails: !isOpenContentDetails })}>
              <div className="title d-flex px-2">
                <span>Content Details</span>
                {isOpenContentDetails ? <ChevronDownIcon className="icons" /> : <ChevronRightIcon className="icons" />}
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <div className="content-details">
                <ThumbnailEditor details={this.props.details} user={this.props.user} cognitoUser={this.props.cognitoUser} Auth={this.props.Auth} Analytics={this.props.Analytics} isAdmin={isEditable} />
                <p className="mt-2">Asset Use</p>
                {isEditable ? (
                  <Select options={accessibilityOptions} styles={selectStyles(200)} className="selector" value={sharedOption} onChange={(e, value, action) => this.handleChangeAccessibility(e)} isDisabled={!isEditable} />
                ) : (
                  <div className="static-label">{isShared ? ASSET_USE.EXTERNAL : ASSET_USE.INTERNAL}</div>
                )}
                {/* FUNNEL STAGE */}
                <p className="mt-2">Funnel Stage</p>
                {isEditable ? (
                  <Dropdown className="custom-dropdown">
                    <Dropdown.Toggle variant="outline-light" id="dropdown-toggle-custom" className="dropdown-toggle-custom" title={funnelStageTitle}>
                      {funnelStageTitle}
                      <span className="caret"></span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Select
                        classNamePrefix="content_select_"
                        styles={selectStyles(200)}
                        className="selector"
                        isMulti
                        options={[{ label: "", value: "__blank__" }, ...funnelOptions]}
                        placeholder="Funnel Stage"
                        value={funnelStage}
                        onChange={(selectedOptions, { action }) => this.onChangeMultiSelection("funnelStage", selectedOptions, action)}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        menuIsOpen
                        components={{ Option: this.CustomOption, MultiValue: this.CustomMultiValue, DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                      />
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <div className="static-label" title={funnelStageTitle}>{funnelStageTitle}</div>
                )}

                {/* CONTENT TYPE */}
                <p className="mt-2">Content Type</p>
                {isEditable ? (
                  <Dropdown className="custom-dropdown">
                    <Dropdown.Toggle variant="outline-light" id="dropdown-toggle-custom" className="dropdown-toggle-custom" title={contentTypeTitle}>
                      {contentTypeTitle}
                      <span className="caret"></span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Select
                        classNamePrefix="content_select_"
                        styles={selectStyles(200)}
                        className="selector"
                        isMulti
                        options={[{ label: "", value: "__blank__" }, ...contentTypeOptions]}
                        placeholder="Content Type"
                        value={contentType}
                        onChange={(selectedOptions, { action }) => this.onChangeMultiSelection("contentType", selectedOptions, action)}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        menuIsOpen
                        components={{ Option: this.CustomOption, MultiValue: this.CustomMultiValue, DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                      />
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <div className="static-label" title={contentTypeTitle}>{contentTypeTitle}</div>
                )}

                {/* PRODUCT */}
                {appOptions && appOptions.enableProducts && (
                  <div>
                    <p className="mt-2">Product</p>
                    {isEditable ? (
                      <Dropdown className="custom-dropdown">
                        <Dropdown.Toggle variant="outline-light" id="dropdown-toggle-custom" className="dropdown-toggle-custom" title={contentProductTitle}>
                          {contentProductTitle}
                          <span className="caret"></span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Select
                            classNamePrefix="content_select_"
                            styles={selectStyles(200)}
                            className="selector"
                            isMulti
                            options={[{ label: "", value: "__blank__" }, ...contentProductOptions]}
                            placeholder="Content Product"
                            value={contentProduct}
                            onChange={(selectedOptions, { action }) => this.onChangeMultiSelection("contentProduct", selectedOptions, action)}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            menuIsOpen
                            components={{ Option: this.CustomOption, MultiValue: this.CustomMultiValue, DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                          />
                        </Dropdown.Menu>
                      </Dropdown>
                    ) : (
                      <div className="static-label" title={contentProductTitle}>{contentProductTitle}</div>
                    )}
                  </div>
                )}

                {/* INDUSTRY */}
                {appOptions && appOptions.enableIndustries && (
                  <div>
                    <p className="mt-2">Industry</p>
                    {isEditable ? (
                      <Dropdown className="custom-dropdown">
                        <Dropdown.Toggle variant="outline-light" id="dropdown-toggle-custom" className="dropdown-toggle-custom" title={contentIndustryTitle}>
                          {contentIndustryTitle}
                          <span className="caret"></span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Select
                            classNamePrefix="content_select_"
                            styles={selectStyles(200)}
                            className="selector"
                            isMulti
                            options={[{ label: "", value: "__blank__" }, ...contentIndustryOptions]}
                            placeholder="Content Industry"
                            value={contentIndustry}
                            onChange={(selectedOptions, { action }) => this.onChangeMultiSelection("contentIndustry", selectedOptions, action)}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            menuIsOpen
                            components={{ Option: this.CustomOption, MultiValue: this.CustomMultiValue, DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                          />
                        </Dropdown.Menu>
                      </Dropdown>
                    ) : (
                      <div className="static-label" title={contentIndustryTitle}>{contentIndustryTitle}</div>
                    )}
                  </div>
                )}

                {/* REGION */}
                {appOptions && appOptions.enableRegions && (
                  <div>
                    <p className="mt-2">Region</p>
                    {isEditable ? (
                      <Dropdown className="custom-dropdown">
                        <Dropdown.Toggle variant="outline-light" id="dropdown-toggle-custom" className="dropdown-toggle-custom" title={contentRegionTitle}>
                          {contentRegionTitle}
                          <span className="caret"></span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Select
                            classNamePrefix="content_select_"
                            styles={selectStyles(200)}
                            className="selector"
                            isMulti
                            options={[{ label: "", value: "__blank__" }, ...contentRegionOptions]}
                            placeholder="Content Region"
                            value={contentRegion}
                            onChange={(selectedOptions, { action }) => this.onChangeMultiSelection("contentRegion", selectedOptions, action)}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            menuIsOpen
                            components={{ Option: this.CustomOption, MultiValue: this.CustomMultiValue, DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                          />
                        </Dropdown.Menu>
                      </Dropdown>
                    ) : (
                      <div className="static-label" title={contentRegionTitle}>{contentRegionTitle}</div>
                    )}
                  </div>
                )}

                <p className="mt-2 mb-0">Tags</p>
                {!isAdmin && Object.entries(tags).length === 0 && (
                  <p>
                    <i>No tags</i>
                  </p>
                )}
                {/* Add tags if admin */}
                {isAdmin && (
                  <div>
                    <p>
                      <i>Add existing or create new tags</i>
                    </p>
                    <div className="add-button">
                      <ContentTagEditor className="mr-2 mt-1" onChange={this.handleTagChange} disabled={!isAdmin} selectedTags={{ ...tags }} />
                    </div>
                  </div>
                )}

                <div className="marks mt-2">
                  {Object.keys(tags).map((key) => (
                    <div key={key} className="d-flex justify-content-between">
                      <div>
                        <FontAwesomeIcon key={key} icon={faBookmark} rotation={270} color={tags[key].color} />
                        <span className="ml-1">
                          <i>{key}</i>
                        </span>
                      </div>
                      {(isAdmin || userId === tags[key].createdBy) && <XCircleIcon className="icons text-white cursor-pointer" onClick={() => this.handleDeleteTag(key)} />}
                    </div>
                  ))}
                </div>
                {isShared && (
                  <div>
                    <p className="mt-2">Short URL</p>
                    <div className="flex-column shortner-box" onDoubleClick={() => this.setState({ isEditShortUrl: true })}>
                      <InputGroup>
                        <InputGroup.Prepend>
                          <InputGroup.Text id="inputGroupPrepend">{domain}</InputGroup.Text>
                        </InputGroup.Prepend>
                        <div className={`short-editor ${isEditShortUrl ? "editing" : ""}`} onClick={() => this.setState({ isEditShortUrl: true })}>
                          <FormControl
                            className={`short-editor ${isEditShortUrl ? "editing" : ""}`}
                            placeholder="Short URL..."
                            aria-label="short_url"
                            aria-describedby="basic-addon1"
                            value={shortPath}
                            onChange={(e) => this.setState({ shortUrl: domain + e.target.value })}
                            disabled={!isEditable || !isEditShortUrl}
                          />
                        </div>
                      </InputGroup>
                      {isEditable && (
                        <div className="d-flex justify-content-end">
                          <div
                            className={`text-right click-edit ${isEditShortUrl ? "editing" : ""}`}
                            onClick={this.onClickShortener}
                            data-cc-analytics-on="click"
                            id="btnItemDetailShortUrlEdit"
                            data-cc-analytics-name="admin-shorturl-customize"
                            data-cc-analytics-attrs={`itemId:${itemId},shortUrl:'${shortUrl.replace("https://", "")}'`}
                          >
                            {isEditShortUrl ? <CheckIcon className="icons" /> : "Click to edit"}
                          </div>
                          {isEditShortUrl && (
                            <div className={`text-right click-edit ${isEditShortUrl ? "editing" : ""}`} onClick={() => this.setState({ shortUrl: _.get(this.props.details, "urls.short", ""), isEditShortUrl: false })}>
                              <XIcon className="icons" />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <br />
                    <div ref={this.shareLinkRef}>
                      <ButtonGroup aria-label="Sharing Actions">
                        <Button variant="outline-light" className="mr-2" size="sm" onClick={this.onClickCopyShortUrl}>
                          LINK
                        </Button>
                        <ButtonShareWithRecipient variant="outline-light" itemId={itemId} itemShortUrl={_.get(this.props, "details.urls.short", "")} container={this.shareLinkRef} changeNotificationPermission={this.changeNotificationPermission} itemType={ShareType.Item} itemTitle={titleShort} />
                        {/* <Button variant="outline-light" className="ml-2" size="sm" 
                          onClick={this.onClickCopyShortUrl}>
                          SHARE
                        </Button> */}
                      </ButtonGroup>
                    </div>
                  </div>
                )}
                {/* <div className="add-button mt-2" onClick={() => this.props.history.push('/analytics')}>
                    <FontAwesomeIcon icon={faChartBar} className="mt-2 mr-2" />See analytics...
                  </div> */}
                {isAdmin && (
                  <div className="add-button field-settings mt-2" onClick={() => this.props.history.push("/team-settings")}>
                    <PlusIcon className="icons mr-2" />
                    Fields settings...
                  </div>
                )}
              </div>
            </Accordion.Collapse>
          </Accordion>
        </div>
        <div className="content-wrapper relative">
          {this.props.isLoading && <LinearProgress color="secondary" />}
          <Accordion defaultActiveKey="2">
            <Accordion.Toggle eventKey="2" className="w-100 accordion-toggle" onClick={() => this.setState({ isOpenContentMeta: !isOpenContentMeta })}>
              <div className="title d-flex">
                <span>Details</span>
                {isOpenContentMeta ? <ChevronDownIcon className="icons" /> : <ChevronRightIcon className="icons" />}
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="2">
              <div className="content-meta">
                <p className="label">Title</p>
                <TitleEditable onChange={(value) => this.onChangeSelection({ contentTitle: value && value !== "" ? value : null })} value={_.get(this.props.details, "meta.contentTitle", "")} className="mb-2" editable={isEditable} />

                {/* send empty string bc of ddb restrictions */}
                <p className="label">Positioning (Internal only)</p>
                <ContentEditable onChange={(value) => this.onChangeSelection({ contentPositioning: value && value !== "" ? value : " " })} value={_.get(this.props.details, "meta.contentPositioning", "")} editable={isEditable} placeholder="Internal description and positioning..." />
                <br />
                {/* send empty string bc of ddb restrictions */}
                <p className="label">Description (Public)</p>
                <ContentEditable onChange={(value) => this.onChangeSelection({ contentDescription: value && value !== "" ? value : " " })} value={_.get(this.props.details, "meta.contentDescription", "")} editable={isEditable} placeholder="Short description visible on collection site pages..." />
                <div className="dates">
                  <div>
                    <p className="label">Date added</p>
                    <p className="date">{moment(_.get(this.props, "details.createdAt", "_")).format("MMM DD, YYYY")}</p>
                  </div>
                  <div>
                    <p className="label">Details updated</p>
                    <p className="date">{moment(_.get(this.props, "details.updatedAt", "_")).format("MMM DD, YYYY")}</p>
                  </div>
                </div>
                <br />
                {isEditable && (
                  <div className="d-flex justify-content-end align-item-center">
                    {/* {isAdmin && <Button variant="outline-danger mt-3" size="sm" onClick={this.onSaveDetails}>SAVE DETAILS</Button>} */}
                    <span className="mt-3 pointer-cursor" onClick={this.handleUpdateItem}>
                      Update Item {_.get(this.props, "details.ext", "") === "html" ? "Link" : "Asset"}
                    </span>
                  </div>
                )}
              </div>
            </Accordion.Collapse>
          </Accordion>
          <Accordion defaultActiveKey="3">
            <Accordion.Toggle eventKey="3" className="w-100 accordion-toggle top-border" onClick={() => this.setState({ isOpenSharingDetails: !isOpenSharingDetails })}>
              <div className="title d-flex">
                <span>Sharing Details</span>
                {isOpenSharingDetails ? <ChevronDownIcon className="icons" /> : <ChevronRightIcon className="icons" />}
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="3">
              {/* The user shares table */}
              <div className="additional-card">
                <ItemDetailViewsTable itemId={itemId} Auth={this.props.Auth} />
              </div>
            </Accordion.Collapse>
          </Accordion>
          <Accordion defaultActiveKey="4">
            <Accordion.Toggle eventKey="4" className="w-100 accordion-toggle top-border" onClick={() => this.setState({ isOpenAdditionalInfo: !isOpenAdditionalInfo })}>
              <div className="title d-flex">
                <span>Additional Info</span>
                {isOpenAdditionalInfo ? <ChevronDownIcon className="icons" /> : <ChevronRightIcon className="icons" />}
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="4">
              <div className="additional-card">{this.renderAdditionalInfo()}</div>
            </Accordion.Collapse>
          </Accordion>
        </div>
        <div className="file-wrapper">
          <div className="favorites">
            <div className="image-button">
              <a href={_.get(this.props, "details.urls.ssl", "")} download target="_blank" rel="noopener noreferrer">
                <img src={getIconByName(_.get(this.props, "details.ext", ""))} alt="" />
              </a>
            </div>
            <div className="file-info">
              {/* <p className="label">File name</p> */}
              <p className="filename">{fileName}</p>
            </div>
            <div
              className="image-button"
              onClick={() => this.handleUpvote(_.get(this.props, "details.id"), isAddUpvote)}
              data-cc-analytics-on="click"
              id={isAddUpvote ? "btnItemDetailUnupvote" : "btnItemDetailUpvote"}
              data-cc-analytics-name={isAddUpvote ? "user-item-upvote" : "user-item-unupvote"}
              data-cc-analytics-attrs={`itemId:${itemId},name:${_.get(this.props, "details.name", "")},userId:${_.get(this.props, "details.userId", "")},path:/item/detail/${itemId}`}
            >
              {/* <FontAwesomeIcon icon={isAddUpvote ? faThumbsUp : faThumbsDown} /> */}
              <img src={isAddUpvote ? iconUpvoteOutlined : iconUpvoteFilled} alt="voted icon" />
              <p>{_.get(this.props, "details.meta.upvoteCount", 0)}</p>
            </div>
            <div className="image-button star">
              <img
                src={isFavorite ? iconFavoriteFilled : iconFavoriteOutlined}
                alt="favorite"
                data-cc-analytics-on="click"
                id={isFavorite ? "btnUnfavoriteItem" : "btnFavoriteItem"}
                data-cc-analytics-name={isFavorite ? "user-item-unfavorite" : "user-item-favorite"}
                data-cc-analytics-attrs={`itemId:${itemId},name:${_.get(this.props, "details.name", "")},userId:${_.get(this.props, "details.userId", "")},path:/item/detail/${itemId}`}
                onClick={() => this.handleFavorite(_.get(this.props, "details.id"), isFavorite)}
              />
              <p>{_.get(this.props, "details.meta.favoriteCount", 0)}</p>
            </div>
          </div>
          {/* Render the file preview */}
          <FileViewMaster details={_.get(this.props, "details", null)} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    settings: state.settings,
    details: (state.item.itemDetail || []).filter(data => !_.isEmpty(data)).find(it => it.id === _.get(ownProps, 'match.params.itemId', null)),
    isLoading: _.get(state.item, 'isLoading', false),
    cognitoUser: state.auth.cognitoUser,
    error: state.item.error,
    Analytics: state.auth.Analytics,
    Auth: state.auth.Auth,
    user: state.auth.tenant,
  };
}

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    clearItem,
    updateItem,
    getItemDetail,
    upvoteItem,
    deleteUpvoteItem,
    favoriteItem,
    deleteFavoriteItem,
    updateShortUrl,
    addTagToItem,
    removeTagFromItem
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ItemDetails);
